import { useState } from 'react';

export function ContactSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d5es1ub10k7tbp4q454g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        form.reset();
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-16 sm:py-20 md:py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em]">
              Let's Connect
            </h2>
            <p className="text-gray-400 text-base sm:text-lg font-light px-4">
              Ready to transform your business? Get in touch with our team
            </p>
          </div>

          <div className="bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl p-6 sm:p-8 md:p-12">
            <form 
              id="contact-form" 
              data-readdy-form 
              onSubmit={handleSubmit}
              className="space-y-5 sm:space-y-6"
            >
              <input type="hidden" name="_to" value="yusufmuhammada4@gmail.com" />
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
                <div>
                  <label className="block text-gray-400 text-sm font-light mb-2">
                    Full Name
                  </label>
                  <input 
                    type="text"
                    name="fullName"
                    required
                    className="w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-purple-400 transition-colors duration-300"
                    placeholder="John Doe"
                  />
                </div>
                <div>
                  <label className="block text-gray-400 text-sm font-light mb-2">
                    Email Address
                  </label>
                  <input 
                    type="email"
                    name="email"
                    required
                    className="w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-purple-400 transition-colors duration-300"
                    placeholder="john@example.com"
                  />
                </div>
              </div>

              <div>
                <label className="block text-gray-400 text-sm font-light mb-2">
                  Company Name
                </label>
                <input 
                  type="text"
                  name="companyName"
                  className="w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-purple-400 transition-colors duration-300"
                  placeholder="Your Company"
                />
              </div>

              <div>
                <label className="block text-gray-400 text-sm font-light mb-2">
                  Service Interest
                </label>
                <select 
                  name="serviceInterest"
                  required
                  className="w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-purple-400 transition-colors duration-300 cursor-pointer"
                >
                  <option value="">Select a service</option>
                  <option value="Software Development & Digital Solutions">Software Development & Digital Solutions</option>
                  <option value="AI Automated Systems">AI Automated Systems</option>
                  <option value="Marketing & Media Solutions">Marketing & Media Solutions</option>
                  <option value="Creative Design & Branding">Creative Design & Branding</option>
                  <option value="High-Tech Gadget Importation">High-Tech Gadget Importation</option>
                </select>
              </div>

              <div>
                <label className="block text-gray-400 text-sm font-light mb-2">
                  Message
                </label>
                <textarea 
                  name="message"
                  rows={5}
                  required
                  maxLength={500}
                  className="w-full bg-black/50 border border-white/10 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-purple-400 transition-colors duration-300 resize-none"
                  placeholder="Tell us about your project..."
                ></textarea>
                <p className="text-gray-500 text-xs mt-1">Maximum 500 characters</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-500/20 border border-green-500/50 rounded-xl p-4 text-green-400 text-sm">
                  ✓ Message sent successfully! We'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-500/20 border border-red-500/50 rounded-xl p-4 text-red-400 text-sm">
                  ✗ Failed to send message. Please try again or contact us directly.
                </div>
              )}

              <button 
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-violet-500 to-purple-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl text-sm sm:text-base font-medium transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/50 hover:scale-[1.02] whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
            <div className="text-center p-5 sm:p-6 bg-black/20 backdrop-blur-sm border border-white/10 rounded-xl">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-3 sm:mb-4 bg-violet-500/20 rounded-xl">
                <i className="ri-mail-line text-xl sm:text-2xl text-violet-400"></i>
              </div>
              <h4 className="text-white text-sm font-light mb-2">Email</h4>
              <p className="text-gray-400 text-xs">tehkzonebusiness.com</p>
            </div>
            <div className="text-center p-5 sm:p-6 bg-black/20 backdrop-blur-sm border border-white/10 rounded-xl">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-3 sm:mb-4 bg-violet-500/20 rounded-xl">
                <i className="ri-phone-line text-xl sm:text-2xl text-violet-400"></i>
              </div>
              <h4 className="text-white text-sm font-light mb-2">Phone</h4>
              <p className="text-gray-400 text-xs">+234 8155210947</p>
            </div>
            <div className="text-center p-5 sm:p-6 bg-black/20 backdrop-blur-sm border border-white/10 rounded-xl sm:col-span-2 md:col-span-1">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-3 sm:mb-4 bg-violet-500/20 rounded-xl">
                <i className="ri-instagram-line text-xl sm:text-2xl text-violet-400"></i>
              </div>
              <h4 className="text-white text-sm font-light mb-2">Instagram</h4>
              <a href="https://instagram.com/tehkzone" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-xs hover:text-violet-400 transition-colors cursor-pointer">
                @tehkzone
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
